<template>
  <v-app-bar
    id="default-app-bar"
    app
    absolute
    class="v-bar--underline elevation-3"
    :color="backgroundColor"
    :clipped-left="$vuetify.rtl"
    :clipped-right="!$vuetify.rtl"
    height="70"
    flat
  >
    <v-app-bar-nav-icon
      class="hidden-md-and-up"
      @click="drawer = !drawer"
    />

    <default-drawer-toggle class="hidden-sm-and-down" />

    <!-- <v-toolbar-title
      class="font-weight-light text-h5"
      v-text="title"
    /> -->
    <span v-if="info && info.username && $vuetify.breakpoint.smAndUp">{{ info.username }} 님, 회의실 예약 시스템에 오신 것을 환영합니다.</span>

    <v-spacer />

    <!-- <default-search class="hidden-sm-and-down" /> -->

    <!-- <default-go-home /> -->

    <!-- <default-notifications /> -->
    <!-- <span v-if="info.username && $vuetify.breakpoint.smAndUp">{{ info.username }} 님, 회의예약 시스템 입니다.</span> -->
    <v-btn
      rounded
      color="primary"
      medium
      @click="manualDown"
    >
      Manual
    </v-btn>
    <default-account />
  </v-app-bar>
</template>

<script>
  // Utilities
  import { get, sync } from 'vuex-pathify'

  export default {
    name: 'DefaultBar',

    components: {
      DefaultAccount: () => import(
        /* webpackChunkName: "default-account" */
        './widgets/Account'
      ),
      DefaultDrawerToggle: () => import(
        /* webpackChunkName: "default-drawer-toggle" */
        './widgets/DrawerToggle'
      ),
      // DefaultGoHome: () => import(
      //   /* webpackChunkName: "default-go-home" */
      //   './widgets/GoHome'
      // ),
      // DefaultNotifications: () => import(
      //   /* webpackChunkName: "default-notifications" */
      //   './widgets/Notifications'
      // ),
      // DefaultSearch: () => import(
      //   /* webpackChunkName: "default-search" */
      //   './widgets/Search'
      // ),
    },

    data: () => ({
      backgroundColor: 'white',
      title: '',
    }),

    computed: {
      ...sync('app', [
        'drawer',
        'mini',
      ]),
      items: get('app/items'),
      info: get('user/info'),
    },

    watch: {
      '$vuetify.theme.dark': {
        handler (val) {
          if (val) {
            this.backgroundColor = 'black'
          } else {
            this.backgroundColor = 'white'
          }
        },
      },
      $route: {
        handler (val) {
          this.setTitle(val)
        },
      },
    },

    created () {
      this.setTitle()
    },

    methods: {
      setTitle () {
        const page = this.items.find(item => item.to === this.$route.path)
        if (page) {
          this.title = page.title
        } else {
          this.title = this.$route.name
        }
      },
      manualDown () {
        window.open(`${
          process.env.NODE_ENV === 'development'
            ? 'http://localhost:3000'
            : ''
        }/api/v1/settings/manual`, '_self')
      },
    },
  }
</script>
